import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@crm/ui';
import { ArrowLeft, UserRound } from 'lucide-react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { PageHeader } from '@/components';
import { useDocumentTitle } from '@/hooks';
import { CustomerCashbackCard } from '@/modules/cashback';
import { CUSTOMERS_ROUTES } from '../api';
import { CustomerForm } from '../components/customer-form';

export function CustomerFormPage() {
  const { id } = useParams<{ id: string }>();
  const isEdit = Boolean(id);

  useDocumentTitle(isEdit ? 'Editar cliente' : 'Novo cliente');

  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <PageHeader
        icon={<UserRound />}
        title={isEdit ? 'Editar cliente' : 'Novo cliente'}
        description="Dados de contato e a unidade que costuma atender esse cliente."
        actions={
          <Button variant="outline" asChild>
            <Link to={CUSTOMERS_ROUTES.LIST}>
              <ArrowLeft className="h-4 w-4" />
              Voltar
            </Link>
          </Button>
        }
      />

      {/* No cadastro novo nao ha historico para mostrar. */}
      {id ? <CustomerCashbackCard customerId={id} /> : null}

      <Card variant="flush" className="mx-auto max-w-2xl">
        <CardHeader>
          <CardTitle className="text-base">Dados do cliente</CardTitle>
          <CardDescription>Apenas o nome e obrigatorio.</CardDescription>
        </CardHeader>
        <CardContent>
          <CustomerForm id={id} onSaved={() => navigate(CUSTOMERS_ROUTES.LIST)} />
        </CardContent>
      </Card>
    </div>
  );
}
